module.exports = __webpack_public_path__ + "static/img/pinterest-dark.845b8ac7.png";